import classNames from "classnames";
import React, { useId, useState } from "react";
import { SVVCheckbox } from "./Checkbox";
import { SVVFormError } from "./FormError";
import { SVVPopover } from "./Popover";
import { CheckboxGroupProps, CheckboxProps } from "./typer";

export function SVVCheckboxGroup({
  options,
  error,
  legend,
  direction,
  required,
  popoverText,
  popoverTitle,
  isFullWidth,
  removeMargin = false,
  description,
  sm,
  id,
}: CheckboxGroupProps) {
  const [errorMessageId] = useState(`feilmelding-${useId()}`);
  const hasPopover = popoverText && popoverTitle;

  return (
    <fieldset
      className={classNames("svv-form-element", {
        "svv-form-element--inline": direction === "horizontal",
        "svv-form-element--with-errors": error,
        "svv-form-element--max-width": !isFullWidth,
        "svv-form-element--margin-bottom": !removeMargin,
      })}
      id={id}
    >
      <legend className={classNames("svv-form-label", { "svv-form-label--inline": hasPopover })}>
        {legend}
        {required && <span aria-hidden="true"> *</span>}
      </legend>
      {/* <div> er ikke lov som barn av legend */}
      {hasPopover && <SVVPopover explanationText={popoverText} title={popoverTitle} />}
      {description && <p className="svv-form-description">{description}</p>}
      {options.map((o: CheckboxProps) => (
        <SVVCheckbox
          key={o.id}
          onChange={o.onChange}
          checked={o.checked}
          sm={sm}
          required={required}
          {...(error && errorMessageId && { "aria-describedby": errorMessageId })}
          {...o}
        />
      ))}
      <div aria-live="assertive">
        {error && <SVVFormError id={errorMessageId}>{error}</SVVFormError>}
      </div>
    </fieldset>
  );
}

SVVCheckboxGroup.displayName = "SVVCheckboxGroup";
